<template>

  <div>
    <b-form-group label="Model" label-class="font-weight-bold">
      <b-checkbox v-model="writeModel">Overschrijven</b-checkbox>
      <treeselect
        :options="brands.nodes"
        disableBranchNodes
        showCount
        v-model="model"
        :clearable="false"
      />
    </b-form-group>

  </div>

</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import BusyBtn from '@/components/BusyBtn';
import SearchPrinter from '@/components/SearchPrinter';

export default
{
    apollo:
    {
        brands:
        {
            query: require('../graphql/query/models_dropdown.gql')
        }
    },
    components: { Treeselect },
    data()
    {
        return {
            brands: { nodes: [] },
            // Input fields
            writeModel: false,
            model: null,
        }
    },
    methods:
    {
        async save(ok)
        {
            const input =
                {
                    ids: this.ids,
                    patch:
                    {
                        model:    this.writeModel ? this.model : null,
                    }
                }

            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/mass_update_printers.gql'),
                    variables: {input}
                }
            );

            ok();
        }
    },
    props:
    {
        ids: { type: Array }
    }
}
</script>

<style>
</style>